<template>
    <div
        id="be-visitatori-gallery"
        class="bg-light"
    >
        <div class="body-wrapper">
            <backend-header />
            <main>
                <div class="barra-titolo-azioni bg-white border-bottom py-2">
                    <div class="container-fluid">
                        <div class="row d-flex justify-content-between flex-wrap align-items-center">
                            <div class="col-sm-8">
                                <h1 class="mb-0">{{$t('Report visitatori gallery')}}</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="controlli-elenco mt-5 row d-flex justify-content-between align-items-center flex-wrap">
                        <div class="col-md-12">
                            <button
                                type="button"
                                class="btn btn-light border"
                                v-b-modal.popupricerca
                            >
                                {{$t('Ricerca con filtri')}}</button>
                        </div>
                        <div class="row filters-labels col-md-12 mt-2">
                            <b-alert
                                dismissible
                                :show="searchViewer.gallery !== ''"
                                @dismissed="clearFilter('gallery')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Gallery')}}: {{getGalleryLabel(searchViewer.gallery)}}</small>
                            </b-alert>
                            <b-alert
                                dismissible
                                :show="searchViewer.status !== ''"
                                @dismissed="clearFilter('status')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Visitatori')}}: {{getStatusLabel(searchViewer.status)}}</small>
                            </b-alert>
                            <b-alert
                                dismissible
                                :show="searchViewer.email !== ''"
                                @dismissed="clearFilter('email')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Email')}}: {{searchViewer.email}}</small>
                            </b-alert>
                            <b-alert
                                dismissible
                                :show="!isAgent && searchViewer.agent !== ''"
                                @dismissed="clearFilter('agent')"
                                class="ml-2 mb-0 mt-1 py-0 pl-1"
                            >
                                <small>{{$t('Collaboratore')}}: {{getAgentLabel(searchViewer.agent)}}</small>
                            </b-alert>
                            <div class="align-middle mt-1">
                                <a
                                    class="ml-2"
                                    href=""
                                    v-if="searchViewer.gallery !== '' || searchViewer.status !== '' || searchViewer.email !== '' || (!isAgent && searchViewer.agent !== '')"
                                    @click.prevent="clearFilter()"
                                >
                                    <small>{{$t('Pulisci tutti i filtri')}}</small>
                                </a>
                            </div>
                        </div>
                        <!--<div class="d-md-flex justify-content-end align-items-center col-md-9 mt-3 mt-md-0">
                            <a href="javascript:void(0);" data-toggle="modal" data-target="#popupcancellazione"
                               type="button" class="btn btn-light border d-none">Cancella</a>
                        </div>-->
                    </div>

                    <b-table
                        class="elenco-visitatori tabella-responsive table mt-3 mb-0"
                        striped
                        id="viewers-table"
                        :per-page="pagination.perPage"
                        :current-page="pagination.currentPage"
                        :items="filteredViewers"
                        :fields="tableHead"
                        :tbody-tr-class="'visitatore mt-0'"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >

                        <!-- HEAD -->
                        <template #head(galleryTitle)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(viewer)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(lastActivity)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(numFavorites)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(numInCart)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(orders)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(view)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(downloadTXT)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>
                        <template #head(downloadPDF)="data">
                            <span class="px-1">{{ data.label }}</span>
                        </template>

                        <!-- TABLE BODY DATA -->
                        <template #cell(galleryTitle)="data">
                            <span class="data-titolo">{{data.item.galleryTitle}}</span>
                        </template>

                        <template #cell(viewer)="data">
                            <span class="data-visitatore">{{data.item.viewer}}</span>
                        </template>

                        <template #cell(lastActivity)="data">
                            <span class="data-ultima-attivita">{{data.item.lastActivity | formatDateSlash}}</span>
                        </template>

                        <template v-slot:cell(numFavorites)="data">
                            <span
                                class="preferiti text-blusbiadito"
                                v-if="data.item.numFavorites"
                            >
                                <router-link
                                    :to="{
                                        name: 'backend-reports-favorites-details',
                                        params: { 'eventId': data.item.galleryId, 'email': data.item.viewer }
                                    }"
                                    class="ml-1 text-blusbiadito"
                                >
                                    <font-awesome-icon :icon="['fas', 'star']" /> {{data.item.numFavorites}}
                                </router-link>
                            </span>
                            <span v-else> - </span>
                        </template>

                        <template v-slot:cell(numInCart)="data">
                            <span
                                class="in-carrello text-blusbiadito"
                                v-if="data.item.numInCart"
                            >
                                <font-awesome-icon :icon="['fas', 'shopping-cart']" /> {{data.item.numInCart}}
                            </span>
                            <span v-else> - </span>
                        </template>

                        <template v-slot:cell(orders)="data">
                            <div v-if="Array.isArray(data.item.orders) && data.item.orders.length">
                                <span
                                    v-for="(order, index) in data.item.orders"
                                    v-bind:key="order.num"
                                >
                                    <a
                                        href="#"
                                        @click="goToOrder(order)"
                                    >{{order}}</a><span v-if="index<data.item.orders.length-1">, </span>
                                </span>
                            </div>
                            <span v-else> - </span>
                        </template>

                        <template v-slot:cell(view)="data">
                            <span
                                class="text-blusbiadito"
                                v-if="data.item.numFavorites"
                            >
                                <router-link
                                    :to="{
                                        name: 'backend-reports-favorites-details',
                                        params: { 'eventId': data.item.galleryId, 'email': data.item.viewer }
                                    }"
                                    class="text-blusbiadito"
                                >
                                    {{ $t('Vedi') }}
                                </router-link>
                            </span>
                            <span v-else> - </span>
                        </template>

                        <template v-slot:cell(downloadTXT)="data">
                            <span
                                class="text-blusbiadito"
                                v-if="data.item.numFavorites"
                            >
                                <font-awesome-icon :icon="['fas', 'file-alt']" />
                                <a
                                    href="#"
                                    class="ml-1 text-blusbiadito"
                                    :title="$t('Scarica in formato testo')"
                                    @click.prevent="onDownloadTXT(data.item)"
                                >{{ $t('Scarica (txt)') }}</a>
                            </span>
                            <span v-else> - </span>
                        </template>

                        <template v-slot:cell(downloadPDF)="data">
                            <span
                                class="text-blusbiadito"
                                v-if="data.item.numFavorites"
                            >
                                <font-awesome-icon :icon="['fas', 'file-pdf']" />
                                <a
                                    href="#"
                                    class="ml-1 text-blusbiadito"
                                    :title="$t('Scarica in formato PDF')"
                                    @click.prevent="onDownloadPDF(data.item)"
                                >{{ $t('Scarica (pdf)') }}</a>
                            </span>
                            <span v-else> - </span>
                        </template>
                    </b-table>

                    <nav
                        class="paginazione mt-3"
                        aria-label="Paginazione"
                    >
                        <b-pagination
                            v-model="pagination.currentPage"
                            :total-rows="paginationRows"
                            :per-page="pagination.perPage"
                            aria-controls="viewers-table"
                            align="right"
                            class="pagination justify-content-end mb-0"
                        />
                    </nav>
                </div>
            </main>
            <backend-footer />
            <!-- popup ricerca visitatori -->
            <b-modal
                id="popupricerca"
                :title="$t('Cerca visitatori gallery')"
                @ok="onPopupRicercaOk"
            >
                <div class="form-group mt-1 mb-2">
                    <label
                        for="gallery"
                        class="mb-0"
                    >{{$t('Gallery')}}</label>

                    <!--b-form-input
                        ref="popupRicercaGallery"
                        list="gallery"
                        autocomplete="off"
                        placeholder="Qualsiasi"
                        :value="searchViewer.gallery"
                        class="datalist-select"
                    ></b-form-input>

                    <b-form-datalist
                        name="gallery"
                        id="gallery"
                    >
                        <option value="">{{$t('Qualsiasi')}}</option>
                        <option
                            v-for="gallery in galleries"
                            :key="gallery.id"
                            :value="gallery.title +'('+gallery.id+')'"
                        >{{ gallery.title }}</option>
                    </b-form-datalist-->
                    <b-select
                        class="form-control"
                        name="gallery"
                        id="gallery"
                        ref="popupRicercaGallery"
                        :value="searchViewer.gallery"
                    >
                        <option value="">{{$t('Qualsiasi')}}</option>
                        <option
                            v-for="gallery in galleries"
                            :key="gallery.id"
                            :value="gallery.id"
                        >
                            {{gallery.title}}
                        </option>
                    </b-select>
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="filtri"
                        class="mb-0"
                    >{{$t('Filtra per')}}</label>
                    <b-form-select
                        ref="popupRicercaStatus"
                        class="form-control"
                        name="filtri"
                        id="filtri"
                        :value="searchViewer.status"
                    >
                        <option value="">{{$t('Tutti')}}</option>
                        <option value="fav">{{$t('Visitatori con preferiti')}}</option>
                        <option value="cart">{{$t('Visitatori con prodotti nel carrello')}}</option>
                        <option value="order">{{$t('Visitatori che hanno effettuato ordini')}}</option>
                        <option value="no-order">{{$t('Visitatori che non hanno effettuato ordini')}}</option>
                    </b-form-select>
                </div>
                <div class="form-group mt-1 mb-2">
                    <label
                        for="email"
                        class="mb-0"
                    >{{$t('Email')}}</label>
                    <input
                        ref="popupRicercaEmail"
                        type="text"
                        class="form-control"
                        name="email"
                        id="email"
                        :value="searchViewer.email"
                    >
                </div>
                <div class="form-group mt-1 mb-2">
                    <b-form-checkbox
                    id="viewDeletedEvents"
                    v-model="checkedViewDeletedEvents"
                    name="viewDeletedEvents"
                    value="true"
                    unchecked-value="false"
                    >{{$t('Visualizza eventi cancellati')}}</b-form-checkbox>
                </div>
                <div
                    class="form-group mt-1 mb-2"
                    v-if="!isAgent"
                >
                    <label class="mb-0">{{ $t("Collaboratore") }}</label>
                    <b-form-select
                        ref="popupRicercaAgent"
                        class="form-control"
                        :value="searchViewer.agent"
                        :options="agents"
                        value-field="fkUtenteAgente"
                        text-field="email"
                        required
                    >
                        <template #first>
                            <b-form-select-option value="">{{$t('Tutti')}}</b-form-select-option>
                        </template>
                    </b-form-select>
                </div>
                <template #modal-footer="{ok,cancel}">
                    <b-button
                        class="btn btn-light border"
                        @click="cancel()"
                    >
                        {{ $t("Annulla") }}
                    </b-button>
                    <b-button
                        class="btn btn-primary btn-rikorda1"
                        @click="ok()"
                    >
                        {{ $t("Cerca") }}
                    </b-button>
                </template>
            </b-modal>

            <!-- popup cancellazione visitatori -->
            <div
                class="modal fade"
                id="popupcancellazione"
                tabindex="-1"
                role="dialog"
                aria-labelledby="popupcancellazioneLabel"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog"
                    role="document"
                >
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5
                                class="modal-title"
                                id="popupcancellazioneLabel"
                            >Cancella visitatore</h5>
                            <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <p class="mb-0">Sei sicuro di voler questo visitatore?</p>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-light border"
                                data-dismiss="modal"
                            >Annulla</button>
                            <button
                                type="button"
                                class="btn btn-danger"
                            >Cancella</button>
                        </div>
                    </div>
                </div>
            </div>

            <b-modal
                id="exportExtension"
                ref="exportExtension"
                title="Estrazione report preferiti"
                ok-only
                ok-title="Continua"
                @ok="onDownload"
            >
                <div>
                    {{$t("Vuoi forzare, nel report, un'estensione diversa per i file immagine? (serve a semplificare eventuali filtri in caso di copia/incolla su Lightroom)") }}
                </div>

                <b-form-radio-group
                    id="radio-group-favorites"
                    v-model="forceExtension"
                    name="radio-group-favorites"
                    class="mt-3"
                >
                    <b-form-radio
                        v-model="forceExtension"
                        name="force-extension-radio"
                        :value="true"
                    >{{ $t('Sì') }}</b-form-radio>
                    <b-form-radio
                        v-model="forceExtension"
                        name="force-extension-radio"
                        :value="false"
                    >{{ $t('No') }}</b-form-radio>
                </b-form-radio-group>

                <b-container
                    fluid
                    v-show="forceExtension"
                    class="mt-3"
                >
                    <b-form-group
                        label="Inserisci estensione:"
                        label-cols-md="4"
                        label-size="md"
                        label-align-md="right"
                        class="mb-0"
                    >
                        <b-input-group
                            size="md"
                            class="w-25"
                        >
                            <b-form-input
                                type="text"
                                name="extension"
                                id="extension"
                                class="rounded-pill rilievo-ombra-interna"
                                v-model="extension"
                            ></b-form-input>
                        </b-input-group>
                    </b-form-group>

                </b-container>
            </b-modal>
        </div>
    </div>
</template>

<script>
import BackendHeader from "../../../components/backend/Header";
import BackendFooter from "../../../components/backend/Footer";
import { BAlert } from "bootstrap-vue";

export default {
    name: "BackendReportsVisitors",

    components: { BackendFooter, BackendHeader, BAlert },

    props: ["mode"],

    data() {
        return {
            viewers: [],
            filteredViewers: [],
            galleries: [],
            checkedViewDeletedEvents: false,
            searchViewer: {
                gallery: "",
                status: "",
                email: "",
                agent: ""
            },
            pagination: {
                perPage: 10,
                currentPage: 1
            },
            sortBy: "lastActivity",
            sortDesc: true,
            tableHead: [
                {
                    key: "galleryTitle",
                    label: "Titolo gallery",
                    thClass: "px-1",
                    tdClass: "titolo align-middle px-1",
                    tdAttr: { "data-title": "Titolo gallery" },
                    sortable: true
                },
                {
                    key: "viewer",
                    label: "Visitatore",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Visitatore" },
                    sortable: true
                },
                {
                    key: "lastActivity",
                    label: "Ultima attività",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Ultima attività" },
                    sortable: true
                },
                {
                    key: "numFavorites",
                    label: "Preferiti",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Preferiti" },
                    sortable: true
                },
                {
                    key: "numInCart",
                    label: "In carrello",
                    thClass: "px-1",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "In carrello" },
                    sortable: true
                },
                {
                    key: "orders",
                    label: "Ordini",
                    thClass: "px-1",
                    thStyle: "width: 15%;",
                    tdClass: "align-middle px-1",
                    tdAttr: { "data-title": "Ordini" }
                },
                {
                    key: "view",
                    label: "",
                    thClass: "px-1",
                    tdClass: "align-middle px-1"
                },
                {
                    key: "downloadTXT",
                    label: "",
                    thClass: "px-1",
                    thStyle: "width: 10%;",
                    tdClass: "align-middle px-1"
                },
                {
                    key: "downloadPDF",
                    label: "",
                    thClass: "px-1",
                    thStyle: "width: 10%;",
                    tdClass: "align-middle px-1"
                }
            ],
            agents: [],

            favoritesExportItem: null,
            favoritesExportFormat: "txt", // txt/pdf
            forceExtension: false,
            extension: ""
        };
    },

    methods: {
        isVisitorsMode() {
            return this.mode === "visitors";
        },

        isFavoritesMode() {
            return !this.isVisitorsMode();
        },

        onPopupRicercaOk() {
            this.searchViewer.gallery =
                this.$refs.popupRicercaGallery.$el.value;
            this.searchViewer.status = this.$refs.popupRicercaStatus.$el.value;
            this.searchViewer.email = this.$refs.popupRicercaEmail.value;
            if (!this.isAgent) {
                this.searchViewer.agent =
                    this.$refs.popupRicercaAgent.$el.value;
            }
                        this.$api
            .backendGetViewersReportWithDeletedEvents(null, this.checkedViewDeletedEvents)
            .then((result) => {
                console.debug("BACKEND_GET_VIEWERS_REPORT", result);
                if (this.isFavoritesMode()) {
                    this.viewers = result.viewers.filter((item) => {
                        return item.numFavorites > 0;
                    });
                } else {
                    this.viewers = result.viewers;
                }
                this.filteredViewers = this.viewers;
                this.galleries = result.eventsList;
                this.agents = result.agents;
                if (this.isAgent && this.viewers.length > 0) {
                    this.searchViewer.agent = this.viewers[0].fkUtenteAgente;
                }
                let params = this.$route.query;
                if (Object.getOwnPropertyNames(params).length > 0) {
                    this.searchViewer.gallery = params.eventId;
                    this.searchViewer.status = params.filter;
                    this.filterCustom();
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_VIEWERS_REPORT", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            });
            this.filterCustom();
        },

        filterCustom() {
            this.filteredViewers = this.viewers.filter((viewer) => {
                let statusFilter = false;
                if (this.searchViewer.status !== "") {
                    switch (this.searchViewer.status) {
                        case "fav":
                            statusFilter = viewer.numFavorites > 0;
                            break;
                        case "cart":
                            statusFilter = viewer.numInCart > 0;
                            break;
                        case "order":
                            statusFilter = viewer.numOrders > 0;
                            break;
                        case "no-order":
                            statusFilter = viewer.numOrders === 0;
                            break;
                        default:
                            statusFilter = true;
                            break;
                    }
                } else {
                    statusFilter = true;
                }
                return (
                    viewer.viewer.includes(this.searchViewer.email) &&
                    (this.searchViewer.gallery !== ""
                        ? viewer.galleryId === this.searchViewer.gallery
                        : true) &&
                    (this.searchViewer.agent !== ""
                        ? viewer.fkUtenteAgente === this.searchViewer.agent
                        : true) &&
                    statusFilter
                );
            });
        },

        clearFilter(filter) {
            switch (filter) {
                case "email":
                    this.searchViewer.email = "";
                    this.filterCustom();
                    break;
                case "gallery":
                    this.searchViewer.gallery = "";
                    this.filterCustom();
                    break;
                case "status":
                    this.searchViewer.status = "";
                    this.filterCustom();
                    break;
                case "agent":
                    if (!this.isAgent) {
                        this.searchViewer.agent = "";
                    }
                    this.filterCustom();
                    break;
                default:
                    this.searchViewer.email = "";
                    this.searchViewer.gallery = "";
                    this.searchViewer.status = "";
                    if (!this.isAgent) {
                        this.searchViewer.agent = "";
                    }
                    this.filterCustom();
                    break;
            }
        },

        goToOrder(orderNum) {
            this.$router.push({
                name: "backend-sales-order",
                params: { orderNum: orderNum }
            });
        },

        getGalleryLabel(galleryId) {
            let gallery = this.galleries.filter((el) => el.id === galleryId);
            return gallery[0] ? gallery[0].title : "";
        },

        getStatusLabel(status) {
            switch (status) {
                case "fav":
                    return "Visitatori con preferiti";
                case "cart":
                    return "Visitatori con prodotti nel carrello";
                case "order":
                    return "Visitatori che hanno effettuato ordini";
                case "no-order":
                    return "Visitatori che non hanno effettuato ordini";
            }
        },

        getAgentLabel(fkUtenteAgente) {
            if (!this.isAgent) {
                let agent = this.agents.filter(
                    (el) => el.fkUtenteAgente === fkUtenteAgente
                );
                return agent[0] ? agent[0].email : "";
            }
        },

        showFiltersLabels() {
            return this;
        },

        onDownload() {
            var extension = this.forceExtension ? this.extension : "";
            this.$api
                .backendDownloadFavorites(
                    this.favoritesExportItem.galleryId,
                    this.favoritesExportItem.viewer,
                    this.favoritesExportFormat,
                    extension
                )
                .then((response) => {
                    console.log(
                        "BACKEND_DOWNLOAD_FAVORITES",
                        response,
                        this.favoritesExportItem
                    );

                    var data = response.data;
                    if (response.mimeType === "application/pdf") {
                        data = Buffer.from(data, "base64");
                    }

                    var filename =
                        response.mimeType === "application/pdf"
                            ? "RikordaEventi preferiti.pdf"
                            : "RikordaEventi preferiti.txt";

                    var fileURL = window.URL.createObjectURL(new Blob([data]));
                    var fileLink = document.createElement("a");

                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", filename);

                    document.body.appendChild(fileLink);
                    fileLink.click();

                    window.URL.revokeObjectURL(fileLink.href);
                })
                .catch((error) => {
                    console.error("BACKEND_DOWNLOAD_FAVORITES", error);
                })
                .then(() => {
                    this.favoritesExportItem = null;
                });
        },

        openExtensionModal() {
            this.forceExtension = false;
            this.extension = "";
            this.$bvModal.show(this.$refs.exportExtension.id);
        },

        onDownloadTXT(item) {
            this.favoritesExportFormat = "txt";
            this.favoritesExportItem = item;
            this.openExtensionModal();
        },

        onDownloadPDF(item) {
            this.favoritesExportFormat = "pdf";
            this.favoritesExportItem = item;
            this.openExtensionModal();
        }
    },

    mounted: function () {
        switch (this.mode) {
            case "visitors":
                this.tableHead.forEach((item) => {
                    switch (item.key) {
                        case "view":
                        case "downloadTXT":
                        case "downloadPDF":
                            item.thClass += " d-none";
                            item.tdClass += " d-none";
                            break;
                    }
                });
                break;
            case "favorites":
                this.tableHead.forEach((item) => {
                    switch (item.key) {
                        case "numInCart":
                        case "orders":
                            item.thClass += " d-none";
                            item.tdClass += " d-none";
                            break;
                    }
                });
                break;
        }

        this.$api
            .backendGetViewersReport()
            .then((result) => {
                console.debug("BACKEND_GET_VIEWERS_REPORT", result);
                if (this.isFavoritesMode()) {
                    this.viewers = result.viewers.filter((item) => {
                        return item.numFavorites > 0;
                    });
                } else {
                    this.viewers = result.viewers;
                }
                this.filteredViewers = this.viewers;
                this.galleries = result.eventsList;
                this.agents = result.agents;
                if (this.isAgent && this.viewers.length > 0) {
                    this.searchViewer.agent = this.viewers[0].fkUtenteAgente;
                }
                let params = this.$route.query;
                if (Object.getOwnPropertyNames(params).length > 0) {
                    this.searchViewer.gallery = params.eventId;
                    this.searchViewer.status = params.filter;
                    this.filterCustom();
                }
            })
            .catch((error) => {
                console.error("BACKEND_GET_VIEWERS_REPORT", error);
                this.$router.push({
                    name: this.$route.meta.gotoOnAuthFailed,
                    params: this.$route.params
                });
            });
    },

    computed: {
        paginationRows() {
            return this.filteredViewers.length;
        },

        isAgent() {
            var userDataBE = this.$store.getters.userDataBE;
            var isAgent = this.$store.getters.isAgent;
            console.debug("USERDATABE", userDataBE);
            return userDataBE && isAgent;
        }
    }
};
</script>

<style scoped>
.filters-labels {
    margin: 0;
    padding-left: 5px;
    padding-right: 5px;
    display: flex;
    align-items: center;
}
</style>
